import React, { useState } from "react";

const AffiliateEarningsCalculator = () => {
  const [countryCode, setCountryCode] = useState("KE");
  const [currency, setCurrency] = useState("KES");

  const [selectedPackage, setSelectedPackage] = useState("");
  const [userCount, setUserCount] = useState(0);
  const [estimatedEarnings, setEstimatedEarnings] = useState(0);

  const commissionRate = 0.2;

  const handleCountryChange = (e) => {
    const code = e.target.value;
    setCountryCode(code);
    setCurrency(code === "KE" ? "KES" : "USD");
    setSelectedPackage(""); // Reset package when country changes
    setUserCount(0);
    setEstimatedEarnings(0);
  };

  const handlePackageChange = (e) => {
    setSelectedPackage(e.target.value);
    setUserCount(0);
    setEstimatedEarnings(0);
  };

  const calculateEarnings = () => {
    if (!selectedPackage || userCount <= 0) return;

    let price = 0;
    if (countryCode === "KE") {
      if (selectedPackage === "premium") price = 299;
      if (selectedPackage === "growth") price = 29499;
      if (selectedPackage === "advanced") price = 5999;
    } else {
      if (selectedPackage === "premium") price = 10;
      if (selectedPackage === "growth") price = 30;
      if (selectedPackage === "advanced") price = 50;
    }

    const total = userCount * price * commissionRate;
    setEstimatedEarnings(total.toFixed(2));
  };

  return (
    <div className="card br40 p-4 pb-5 pt-5">
        <h2 className="mb-0 hmpg-header">
          <b>Estimate Your Earnings</b>
        </h2>
        <p className="text-muted font8">
          See how much you could make by referring vendors to Kadhr.
        </p>

        <div className="affiliate-calculator-body">
            {/* Country Selector */}
            <div className="mb-3">
              <label className="form-label">Select Country</label>
              <select
                className="form-select"
                value={countryCode}
                onChange={handleCountryChange}
              >
                <option value="KE">Kenya (KES)</option>
                <option value="US">Other (USD)</option>
              </select>
            </div>

            {/* Package Selector */}
            {countryCode && (
              <div className="mb-3">
                <label className="form-label">Select Package</label>
                <select
                  className="form-select"
                  value={selectedPackage}
                  onChange={handlePackageChange}
                >
                  <option value="">-- Select Package --</option>
                  <option value="premium">Premium</option>
                  <option value="growth">Growth</option>
                  <option value="advanced">Advanced</option>
                </select>
              </div>
            )}

            {/* Number of Users Input */}
            {selectedPackage && (
              <div className="mb-3">
                <label className="form-label">
                  Number of Users for {selectedPackage.charAt(0).toUpperCase() + selectedPackage.slice(1)}
                </label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter number"
                  value={userCount}
                  onChange={(e) => setUserCount(parseInt(e.target.value) || 0)}
                />
              </div>
            )}

            {/* Calculate Button */}
            {selectedPackage && (
              <button
                className="btn btn-dark col-12 mt-2"
                onClick={calculateEarnings}
              >
                Calculate Earnings
              </button>
            )}

            {/* Display Result */}
            {estimatedEarnings > 0 && (
              <div className="alert alert-warning mt-4 text-center">
                <strong>Estimated Earnings: </strong>
                {currency} {Math.round(estimatedEarnings)}
              </div>
            )}
        </div>
    </div>
  );
};

export default AffiliateEarningsCalculator;
